module.exports = __webpack_public_path__ + "media/images/iconLockClosed__inFrontOfAccent-2a1bf4237c1689fc8942a809d00b42be.png";